import { render, staticRenderFns } from "./Barn.vue?vue&type=template&id=ca22abf8&scoped=true&"
import script from "./Barn.vue?vue&type=script&lang=js&"
export * from "./Barn.vue?vue&type=script&lang=js&"
import style0 from "./Barn.vue?vue&type=style&index=0&id=ca22abf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca22abf8",
  null
  
)

export default component.exports